export const PLATAFORMA = ["fb", "ig", "meta"]

export const OBJETIVO = ["awareness", "cadastros", "conversao", "engajamento", "trafego", "views"]
